import React from 'react';
import Child from '../components/Child';

const Children = () => <Child />;

export default Children;
